import { UserStateAtom } from "./AuthorizationState";
import { useAtom } from "jotai";

export default function useUserContext() {
  const [UserState] = useAtom(UserStateAtom);

  return UserState;
}
